<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Novo Local</span> <v-breadcrumbs class="app-breadcrumb"
                            divider="›" :items="[
                                {
                                    text: 'Home',
                                    disabled: false,
                                    to: '/home',
                                    exact: true,
                                },
                                {
                                    text: 'Locais',
                                    disabled: false,
                                    to: '/locais',
                                    exact: true,
                                },
                                {
                                    text: 'Novo',
                                    disabled: true,
                                    exact: true,
                                },
                            ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group" style="padding-right: 16px;">
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="add"
                            :loading="dataset.loading" v-if="page.isNew">Salvar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataset.loading" v-if="!page.isNew">Atualizar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/locais">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card class="form-card">
                    <!-- <v-card-title class="form-card-title">Dados do Local</v-card-title> -->
                    <v-card-text>
                        <v-form ref="form" id="locationForm" @submit.prevent="saveLocation">
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="dataset.data.name" label="Nome do Local"
                                        :rules="[$rules.required]" outlined dense hide-details="auto"></v-text-field>
                                </v-col>
                            </v-row>

                            <v-divider class="my-4"></v-divider>

                            <v-row class="mt-4">
                                <v-col cols="12">
                                    <h3 class="mb-4">Empresas (Tabela de Preços)</h3>
                                    <v-btn color="primary" small class="mb-4" @click="addCustomer">
                                        + Adicionar empresa
                                    </v-btn>

                                    <v-expansion-panels flat>
                                        <v-expansion-panel v-for="(item, index) in dataset.data.customers"
                                            :key="item.id || index" class="mb-2 elevation-1">
                                            <v-expansion-panel-header>
                                                <v-row no-gutters align="center">
                                                    <v-col cols="12">
                                                        <strong>
                                                            {{ item.customer ?
                                                                item.customer.name :
                                                                'Nenhuma empresa selecionada' }}
                                                        </strong>
                                                    </v-col>
                                                </v-row>
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                <v-row>
                                                    <v-col sm="7">
                                                        <v-select v-model="item.customer" :items="dataset.customers"
                                                            item-text="name" item-value="id" label="Clientes"
                                                            :rules="[$rules.required]" outlined dense return-object
                                                            hide-details="auto"></v-select>
                                                    </v-col>
                                                    <v-col sm="4">
                                                        <v-currency-field label="Valor" dense v-model="item.value"
                                                            prefix="R$" :allowNegative=false hide-details="auto"
                                                            outlined>
                                                        </v-currency-field>
                                                    </v-col>
                                                    <v-col sm="1" class="d-flex align-center justify-end">
                                                        <v-btn color="red" text icon @click="removeCustomer(item, index)"
                                                            aria-label="Remover cliente">
                                                            <v-icon>mdi-delete</v-icon>
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </v-col>
                            </v-row>

                            <v-divider class="my-4"></v-divider>

                            <v-row class="mt-4">
                                <v-col cols="12" md="6">
                                    <v-currency-field label="Valor" dense v-model="dataset.data.value_driver"
                                        prefix="R$" :allowNegative=false hide-details="auto" outlined>
                                    </v-currency-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';

export default {
    name: 'LocationsCreate',
    data: () => ({
        page: {
            isNew: false,
            title: ''
        },
        dataset: {
            data: {
                customers: []
            },
            loading: false
        },
    }),

    created() {
        this.loadData()
    },

    methods: {

        goBack() {
            this.$router.replace("/locais");
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();

            await this.loadCustomers();
            await this.load();
        },

        setPage() {
            this.page.isNew = this.$route.params.id == "novo"
            this.page.title = this.page.isNew ? "Novo local" : "Detalhes do local";
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Locais",
                disabled: false,
                to: "/locais",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.isNew ? "Incluir local" : "Detalhes do local",
                disabled: true,
                exact: true,
            });
        },

        async load() {
            if (this.page.isNew) return;

            this.dataset.loading = true

            try {
                const result = await axios.get(`/api/v2/locations/${this.$route.params.id}`);

                this.dataset.data = result.data.content.data

                this.dataset.data.address = { name: this.dataset.data.address, address_iid: this.dataset.data.address_iid }

                this.dataset.addresses = [this.dataset.data.address]

            } catch (error) {
                this.$dialog.notify.error('Ocorreu um erro ao encontrar as informações do passageiro, tente novamente!', {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async loadCustomers() {
            this.dataset.loading = true;
            try {
                const response = await axios.get('/api/v2/customers', { params: { start: 0, limit: 200 } });
                this.dataset.customers = response.data.content.data
            } catch (error) {
                console.error("Erro ao buscar customers:", error);
            } finally {
                this.dataset.loading = false;
            }

        },

        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja salvar o passageiro?',
                title: 'Salvar passageiro',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.post(`/api/v2/locations`, payload, { config: { headers: { "Content-Type": "application/json" } } });

                this.$dialog.notify.info("Local salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar o local?',
                title: 'Atualizar local',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.patch(`/api/v2/locations/${this.$route.params.id}`, payload, { config: { headers: { "Content-Type": "application/json" } } });

                this.$dialog.notify.info("Local salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        addCustomer() {
            this.dataset.data.customers.push({ customer: null, value: 0 })
        },

        async removeCustomer(item, index) {
            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja remover a empresa?',
                title: 'Remover empresa',
                actions: {
                    false: 'Cancelar',
                    true: 'Remover'
                }
            })

            if (!proceedAction) return;

            if (!item.id) {
                this.dataset.data.customers.splice(index, 1);
                return;
            }

            this.dataset.loading = true;

            try {
                await axios.delete(`/api/v2/locations/${this.$route.params.id}/customers/${item.id}`);

                this.$dialog.notify.info("Empresa removida com sucesso", { position: "top-right", timeout: 2000 });

                this.dataset.data.customers.splice(index, 1);
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
            // this.dataset.data.customers.splice(index, 1)
        },

        buildPayload() {
            const data = {
                name: this.dataset.data.name,
                value_driver: this.dataset.data.value_driver,
                customers: this.dataset.data.customers.map((x) => {
                    let data = {
                        value: x.value,
                        customer_id: x.customer.id,
                    }

                    if (x.id) data.id = x.id;
                    return data;
                })
            }

            return data;
        },
    },
};
</script>